import { CASH_TRANSACTIONS } from '../actionTypes';

const initialState = {
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CASH_TRANSACTIONS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
